import { useTranslation } from '@flecto/translations'

import { PageProductList } from '../..'
import { useStoreDetails } from '../../hooks/useStoreDetails'
import { useProductListFilters } from '../PageProductList/useProductListFilters'

export function PageSearch() {
  const { t } = useTranslation('store', { keyPrefix: 'store-page-search' })

  const { filters } = useProductListFilters()

  const store = useStoreDetails()

  const title = filters.q
    ? t('title_search', { term: filters.q })
    : t('label_search_results')

  return (
    <PageProductList
      htmlTitle={t('html_title', { store: store?.name })}
      htmlMetaDescription={t('html_meta_description')}
      title={title}
      subtitle={''}
    />
  )
}
